import axios from "axios";
import pinia from "@/pinia";
import { useAccountStore } from "@/store/account";
import { validateToken } from "@/utils/jwtcontrol";

let refreshPromise = null;

export async function initializeSession(forceRefresh = false) {
  const accountStore = useAccountStore(pinia);

  /*
   * Jika session sudah pernah dicek dan tidak dipaksa refresh,
   * tidak perlu request lagi.
   */

  if (accountStore.initialized && !forceRefresh) {
    return !!accountStore.accessToken;
  }

  /*
   * Jika sedang ada refresh yang berjalan,
   * gunakan promise yang sama.
   */

  if (refreshPromise) {
    return refreshPromise;
  }

  accountStore.startLoading();

  refreshPromise = (async () => {
    try {
      const res = await axios.post(
        "https://tka-api2.kemnaker.go.id/account/refresh-token",
        {},
        {
          withCredentials: true,
        },
      );

      //console.log("result dari auth.js ",res)

      /*
       * Sesuaikan jika struktur response backend berbeda
       */

      const cekvalidasitoken = validateToken(res.data.row.token);

      if (cekvalidasitoken.isValid === false) {
        return false;
      }

      const token = res.data?.row?.token ?? res.data?.token;

      const user = cekvalidasitoken.decoded.username;

      //console.log("validasi token", validateToken(res.data.row.token));

      if (!token) {
        throw new Error("Token kosong.");
      }

      accountStore.setSession(token, user);

      return true;
    } catch (err) {
      accountStore.clearSession();

      //console.log("dari auth.js ",err.response)
      return err;
    } finally {
      accountStore.finishLoading();

      refreshPromise = null;
    }
  })();

  return refreshPromise;
}
